module.exports = fox._r("images/logo.png", __webpack_public_path__ + "images/logo.png");


//////////////////
// WEBPACK FOOTER
// ./images/logo.png
// module id = 47
// module chunks = 2